import {
  Backdrop,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import zIndex from "@mui/material/styles/zIndex";

import { ReactComponent as Close } from "../../../../Assets/Images/Close.svg";
import { Heading3, Heading4 } from "../../../atoms/Typography/Heading/Heading";
import {
  ConfirmMessageBoxStyle,
  ConfirmMessageBoxStyle2,
  ConfirmationMessageBoxButtonStyle,
  ConfirmationMessageBoxButtonStyle2,
  ConfirmationMessageBoxCloseStyle,
} from "./ConfirmMessageBox.style";

export const ConfirmMessageBox = ({
  isOpen,
  setIsOpen,
  heading,
  positiveButton,
  negativeButton,
  children,
  negativeButtonAction,
  positiveButtonAction,
}) => {
  return (
    <>
      <Paper sx={{ position: "absolute", width: "auto" }}>
        <Modal open={isOpen}>
          <>
            <Grid container direction={"column"} sx={ConfirmMessageBoxStyle}>
              <IconButton
                style={ConfirmationMessageBoxCloseStyle}
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                <Close style={{ width: "10.88px", height: "10.88px" }} />
              </IconButton>
              <Grid item mb={"12px"}>
                <Heading3 text={heading} />
              </Grid>
              <Grid item mb={"12px"}>
                {children}
              </Grid>
              <Grid item mb={"12px"}>
                <Divider />
              </Grid>
              <Grid item>
                <Stack direction={"row"} spacing={2}>
                  <Button
                    onClick={negativeButtonAction}
                    variant="lightBlue"
                    sx={ConfirmationMessageBoxButtonStyle}
                  >
                    {negativeButton}
                  </Button>
                  <Button
                    onClick={positiveButtonAction}
                    variant="mediumBlue"
                    sx={ConfirmationMessageBoxButtonStyle}
                  >
                    {positiveButton}
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </>
        </Modal>
      </Paper>
      <Backdrop style={{ zIndex: zIndex.drawer + 1 }} open={isOpen} />
    </>
  );
};

export const ConfirmMessageBoxType2 = ({
  isOpen,
  close,
  setIsOpen,
  heading,
  positiveButton,
  negativeButton,
  children,
  buttonspace,
  negativeButtonAction,
  positiveButtonAction,
  noModal,
}) => {
  return (
    <>
      {!noModal ? (
        <Paper sx={{ position: "absolute", width: "auto" }}>
          <Modal open={isOpen} onClose={close}>
            <>
              <Grid container direction={"column"} sx={ConfirmMessageBoxStyle2}>
                <Grid item mb={"12px"}>
                  <Stack>
                    <Heading4 text={heading} />
                    <IconButton
                      style={ConfirmationMessageBoxCloseStyle}
                      onClick={() => {
                        if (setIsOpen) {
                          setIsOpen(!isOpen);
                        } else if (close) {
                          close();
                        }
                      }}
                    >
                      <Close style={{ width: "10.88px", height: "10.88px" }} />
                    </IconButton>
                  </Stack>
                </Grid>
                <Grid item mb={"12px"}>
                  <Divider />
                </Grid>
                <Grid item mb={"12px"}>
                  {children}
                </Grid>

                <Grid item width={"100%"}>
                  <Stack
                    direction={"column"}
                    spacing={buttonspace ? buttonspace : 2}
                    width={"100%"}
                  >
                    <Button
                      fullWidth
                      onClick={negativeButtonAction}
                      variant="OuterLineBlue"
                      sx={ConfirmationMessageBoxButtonStyle2}
                    >
                      {negativeButton}
                    </Button>
                    <Button
                      onClick={positiveButtonAction}
                      variant="OuterLineBlue"
                      sx={ConfirmationMessageBoxButtonStyle2}
                    >
                      {positiveButton}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </>
          </Modal>
        </Paper>
      ) : (
        <Grid container direction={"column"}>
          {children && (
            <Grid item mb={"12px"}>
              {children}
            </Grid>
          )}

          <Grid item width={"100%"}>
            <Stack
              direction={"column"}
              spacing={buttonspace ? buttonspace : 2}
              width={"100%"}
            >
              <Button
                fullWidth
                onClick={negativeButtonAction}
                variant="OuterLineBlue"
                sx={ConfirmationMessageBoxButtonStyle2}
              >
                {negativeButton}
              </Button>
              <Button
                onClick={positiveButtonAction}
                variant="OuterLineBlue"
                sx={ConfirmationMessageBoxButtonStyle2}
              >
                {positiveButton}
              </Button>              
            </Stack>
          </Grid>
        </Grid>
      )}
      {!noModal && (
        <Backdrop
          style={{ zIndex: zIndex.drawer + 1 }}
          open={isOpen}
          onClick={() => console.log("first")}
        />
      )}
    </>
  );
};
